<template>
  <ActionMenuPopover
    :actionMenuItems="menuOptions"
    @onActionMenuClick="item => $emit('onMenuItemClick', item)"
    :context="context"
  >
    <template v-slot:popoverButton>
      <PopoverButton
        class="h-full bg-transparent hover:bg-white hover:text-gray-900 text-white py-2 px-3 leading-4 text-sm inline-flex items-center justify-center rounded focus:outline-none transition ease-in-out duration-150 border border-transparent font-medium focus:outline-none"
      >
        <UIIcon icon="heroicons-solid:dots-vertical" class="w-5 h-5" />
      </PopoverButton>
    </template>
  </ActionMenuPopover>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { UIIcon } from '@gohighlevel/ghl-canvas'
import { PopoverButton } from '@headlessui/vue'
import ActionMenuPopover from './ActionMenuPopover.vue'

export default defineComponent({
  components: {
    UIIcon,
    PopoverButton,
    ActionMenuPopover,
  },
  props: {
    menuOptions: {
      type: Object,
      required: false,
    },
    context: { type: String, required: false, default: '_' },
  },
  setup(props, { emit }) {
    return {}
  },
})
</script>

<style scoped></style>
